import { render, staticRenderFns } from "./J-1-2a__HR_Resume.vue?vue&type=template&id=6e2f6c3f&"
import script from "./J-1-2a__HR_Resume.vue?vue&type=script&lang=js&"
export * from "./J-1-2a__HR_Resume.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports